import React from 'react';
import { Alert } from 'react-bootstrap';
import Spinner from 'components/Spinner/index.jsx';
import IntlString from 'components/media/IntlString/index.jsx';

function checkEntity(entity, emptyMessage, errorMessage = 'Error fetching data') {
  const { loading, error, list } = entity;
  if (loading && !list) {
    return <Spinner />;
  }
  if (error) {
    return (
      <Alert variant="danger">
        <IntlString message={errorMessage} />
      </Alert>
    );
  }
  if (emptyMessage && !loading && list && list.length === 0) {
    if (typeof emptyMessage === 'object' && !emptyMessage.id) {
      return emptyMessage;
    }
    return <Alert variant="info"><IntlString message={emptyMessage} /></Alert>;
  }
  return null;
}

export default checkEntity;
